<template>
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <div class="table-wrapper">
            <el-table :data="rows" v-loading="loading" style="width: 100%">
                <el-table-column prop="id" label="ID" width="200" />
                <el-table-column prop="userId" label="用户ID" width="200">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewUser(scope.row.userId)">{{
                            scope.row.userId
                        }}</el-link>
                        <CopyButton :text="scope.row.userId" />
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="反馈内容" width="300" />
                <el-table-column prop="createdAt" label="时间" width="200">
                    <template #default="scope">
                        {{ $formatTime(scope.row.createdAt) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
            <el-pagination v-model:current-page="filters.page" v-model:page-size="filters.size"
                :page-sizes="[10, 20, 50]" :total="filters.total" layout="total, sizes, prev, pager, next, jumper"
                @current-change="loadData" @size-change="loadData" />
        </div>
    </el-card>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { apiCall } from "@/utils/api";

const route = useRoute();
const router = useRouter();

const loading = ref(false);

const rows = ref([]);

const filters = reactive({
    page: Number(route.query.page) || 1,
    size: Number(route.query.size) || 20,
    total: 0,
});

watch(
    filters,
    (val) => {
        router.replace({ query: { ...val } });
    },
    { deep: true }
);

async function loadData() {
    loading.value = true;

    const params = {
        page: filters.page || 1,
        size: filters.size || 20,
    };

    const response = await apiCall("feedback.getFeedbacks", params);
    if (!response) {
        return false;
    }
    filters.total = response.count;
    rows.value = response.rows;

    loading.value = false;
}

function viewUser(id) {
    router.push(`/user/${id}`);
}

onMounted(async () => {
    await loadData();
});
</script>

<style scoped></style>
